import { render } from "./RiSidepanel.vue?vue&type=template&id=8569c0e0"
import script from "./RiSidepanel.vue?vue&type=script&lang=js"
export * from "./RiSidepanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiSidepanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8569c0e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8569c0e0', __exports__)) {
    api.reload('8569c0e0', __exports__)
  }
  
  module.hot.accept("./RiSidepanel.vue?vue&type=template&id=8569c0e0", () => {
    api.rerender('8569c0e0', render)
  })

}


export default __exports__